import { Link } from "react-router-dom";
import { XCircle, Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_LINK } from "@/lib/data";

export default function PaymentCancel() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-[#06130D] px-5 grain relative" data-testid="payment-cancel-page">
      <div className="w-full max-w-lg rounded-3xl border border-amber-500/25 bg-[#0B1D14]/90 p-8 text-center sm:p-10">
        <XCircle className="mx-auto text-rose-400" size={48} />
        <h1 className="font-display mt-6 text-3xl font-black text-amber-50">Checkout cancelled</h1>
        <p className="mt-3 text-sm leading-relaxed text-emerald-100/70">
          No charge was made. Your spot isn't reserved yet — holiday dates fill fast, so grab yours when you're ready.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" data-testid="cancel-home-link" className="rounded-full bg-gradient-to-r from-amber-500 to-amber-400 px-8 py-3.5 text-sm font-bold uppercase tracking-widest text-stone-950 transition-all hover:from-amber-400 hover:to-amber-300 gold-glow">
            Try Again
          </Link>
          <a href={PHONE_LINK} className="inline-flex items-center gap-2 rounded-full border border-amber-500/40 px-6 py-3.5 text-sm font-bold text-amber-300 transition-all hover:bg-amber-500/10">
            <Phone size={15} /> {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </main>
  );
}
